import React from "react";
import "./CellPlaceholder.scss";

/**
 * An empty, sized stand-in for a content cell that this particular row doesn't
 * fill. A column is present in the table because *some* row type uses it, so
 * rows that have nothing to show still need to reserve the column's footprint
 * to keep every row aligned. Mirrors the drag/expand column's empty-div
 * placeholder in BaseTableV2.
 *
 * `size` matches the icon-button footprints the content cells render, so the
 * reserved space lines up with populated rows.
 */
export const CellPlaceholder = ({
  size = "large",
}: {
  size?: "large" | "medium";
}) => {
  return (
    <div
      className="entity-cell-placeholder"
      data-size={size}
      aria-hidden="true"
    />
  );
};
